import { useEffect } from 'react';
import { Section, CTA } from 'react-scale/components';
import cn from 'classnames';

import s from './spin-banner.module.css';

const TextSpinner = ({ overline, underline, phrases = [], cta }) => {
  useEffect(() => {
    document.documentElement.style.setProperty('scroll-behavior', 'smooth');

    return () => {
      document.documentElement.style.removeProperty('scroll-behaviour');
    };
  }, []);

  return (
    <Section>
      <div>
        <div className={s['spin-wrapper']}>
          <p className="text-gradient">{overline ?? 'Extract any field from'}</p>

          <div className="h-12 mt-1 lg:h-20 md:h-14 md:mt-3 xl:mt-0">
            <div className={s.cubespinner}>
              <div className={s.face1}>{phrases[0]?.name}</div>
              <div className={s.face2}>{phrases[1]?.name}</div>
              <div className={s.face3}>{phrases[2]?.name}</div>
              <div className={cn('whitespace-nowrap', s.face4)}>{phrases[3]?.name}</div>
              <div className={s.face5}>{phrases[4]?.name}</div>
              <div className={s.face6}>{phrases[5]?.name}</div>
            </div>
          </div>

          <p className="text-gradient">{underline ?? 'at 99%+ accuracy'}</p>
        </div>
      </div>

      <div className={s.cta}>{cta && <CTA cta={cta} />}</div>
    </Section>
  );
};

export default TextSpinner;
